export const placeholderTexts = [
  "ランチが美味しかった！",
  "最近読んだ本についてシェアしよう",
  "週末の予定を教えてください",
  "新しい趣味を始めました",
  "今日はどんな一日でしたか？",
  "お気に入りのカフェを紹介します",
  "ちょっとした嬉しい出来事がありました",
  "最近ハマっていることを語りたい",
  "この映画、最高だった！",
  "ちょっと愚痴をこぼしてもいいですか？",
  "今朝の空がきれいだった",
  "音楽の話をしよう",
  "仕事での小さな成功を記録",
  "旅行の思い出をシェアします",
  "誰かにおすすめしたい本がある",
  "今日の学びをメモしておこう",
  "季節の変化を感じる瞬間",
  "お気に入りの写真を投稿しよう",
  "コーヒー片手に一言",
  "アイデアを思いついた！",
  "少しだけ昔を思い出してみた",
  "気になるニュースを語りたい",
  "今日のごはん記録",
  "やる気が出ない日もあるよね",
  "散歩中に見つけた小さな発見",
  "これって私だけ？",
  "誰か共感してくれる？",
  "最近のマイブームを共有",
  "ちょっと深い話をしてみたい",
  "心に残った言葉を書いてみよう",
  "これから挑戦したいこと",
  "目標をひとつ決めました",
  "最近のお気に入りアプリ",
  "今日の出来事をひとことで",
  "感謝の気持ちを伝えたい",
  "やりたいことリストを更新中",
  "癒された瞬間を残しておこう",
  "少しだけ自分を褒めてみよう",
  "これからの計画を整理したい",
  "ちょっとした気づきを共有",
  "夢に近づくための一歩",
  "最近見た印象的な動画",
  "推しが尊い…！",
  "お気に入りの曲を紹介",
  "今日の空模様を一言で",
  "運が良かった出来事！",
  "最近買ってよかったもの",
  "眠れない夜に考えていたこと",
  "ちょっと語りたいテーマがある",
  "作業のお供はこれ！",
  "ふと感じたことをメモ",
  "やっと終わった〜！",
  "頑張った自分をねぎらう時間",
  "最近気になる言葉",
  "誰かに相談したいことがある",
  "今日の気分を表すなら？",
  "ちょっとした豆知識を共有",
  "好きなものを語るだけの日",
  "運動してスッキリした！",
  "最近観たアニメについて話したい",
  "誰かおすすめの映画教えて！",
  "雨の日の過ごし方",
  "今日の失敗談を笑い話に",
  "お気に入りの服を見つけた！",
  "懐かしい思い出を振り返る",
  "ちょっと未来の話をしよう",
  "最近のトレンドどう思う？",
  "目の前の景色を共有したい",
  "お祝いしたいことがあります！",
  "読んでほしい記事がある",
  "最近の出来事をまとめてみた",
  "自分へのご褒美タイム",
  "これからの自分にひとこと",
  "最近のマイブームレシピ",
  "誰かの言葉に救われた日",
  "最近観たドラマの感想",
  "思いついたアイデアを残しておこう",
  "静かな時間を過ごしています",
  "好きな香りの話をしたい",
  "今日もおつかれさま！",
  "予定が急に変わった！",
  "これはちょっと感動した",
  "自分だけのこだわりを語ろう",
  "挑戦したいことを宣言！",
  "小さな幸せを見つけた",
  "好きな天気について話したい",
  "最近のお気に入りの場所",
  "気分転換にやってみたこと",
  "読書記録を残しておこう",
  "次に行きたい場所を考えてる",
  "ちょっとした反省メモ",
  "今日のインスピレーション",
  "誰かの笑顔に救われた日",
  "最近気づいたことを書きたい",
  "お気に入りの時間帯について語る",
  "この一年を振り返ってみた",
  "明日やりたいことリスト",
  "好きな映画のワンシーンを思い出す",
  "一言だけつぶやきたい",
  "最近よく考えるテーマについて",
  "これから楽しみなイベント",
  "気になるガジェットをメモ",
  "今日はちょっと休もうと思う",
  "いいことがあった日！",
];
